import { useEffect, useRef } from 'react';
import { getAmplitudeClient } from '../utils/amplitude-client';
// In an effect so it only runs in the browser, never during SSR.
export const useAmplitudeInit = ({ environment, apiKey }, { enabled = true, ...options } = {}) => {
    // init() runs once, so only `enabled` needs to re-trigger it.
    const optionsRef = useRef(options);
    optionsRef.current = options;
    useEffect(() => {
        if (!enabled)
            return;
        const amplitude = getAmplitudeClient({ environment, apiKey });
        if (amplitude && apiKey)
            amplitude.init(apiKey, optionsRef.current);
    }, [environment, apiKey, enabled]);
};
//# sourceMappingURL=use-amplitude-init.js.map